import * as yup from 'yup';

export const taskSchema = yup.object().shape({
  name: yup.string().required('tasks.taskNameRequired'),
  description: yup.string().required('tasks.taskDescriptionRequired'),
});